module.exports = __webpack_public_path__ + "static/media/Sani1.597e984f.jpg";